<app-button #rla="routerLinkActive" *ngFor="let item of items" [label]="item.descr" [icon]="item.icon"
            [fullWidth]="true" [large]="true" [routerLink]="[menuCode[item.front_code]]"
            [type]="rla.isActive ? buttonType.primaryButton : buttonType.blueButton"
            routerLinkActive="active"></app-button>

